export default class ClickAddClass {
  constructor() {
    let TARGET_CLASS_NAME = 'js-click';
    this.CLICK_CLASS_NAME = 'is-click-on';
    this.CLICK_PARENT_CLASS_NAME = 'is-click-on';
    // this.LEAVE_CLASS_NAME = 'is-leave';
    this.elms = document.getElementsByClassName(TARGET_CLASS_NAME);
    this.clickEvent();
  }

  clickEvent() {
    for (let i = 0; i < this.elms.length; i++) {
      let _this = this;
      let elm = this.elms[i];

      elm.addEventListener('click', function() {
        this.classList.toggle(_this.CLICK_CLASS_NAME);
        this.parentNode.classList.toggle(_this.CLICK_PARENT_CLASS_NAME);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/components/ClickAddClass.js